import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["compliance", "emailCoordination", "predefinedAnswers", "support", "complianceDiv", "emailCoordinationDiv", "predefinedAnswersDiv", "supportDiv", "model", "modelParameterDiv", "manualModel"]

  static values = {
    modelsWithoutParameters: Array
  }

  toggle() {
    if (this.hasComplianceTarget && this.hasComplianceDivTarget) {
      this.complianceDivTarget.style.display = this.complianceTarget.checked ? "" : "none"
    }
    if (this.hasEmailCoordinationTarget && this.hasEmailCoordinationDivTarget) {
      this.emailCoordinationDivTarget.style.display = this.emailCoordinationTarget.checked ? "" : "none"
    }
    if (this.hasPredefinedAnswersTarget && this.hasPredefinedAnswersDivTarget) {
      this.predefinedAnswersDivTarget.style.display = this.predefinedAnswersTarget.checked ? "" : "none"
    }
    if (this.hasSupportTarget && this.hasSupportDivTarget) {
      this.supportDivTarget.style.display = this.supportTarget.checked ? "" : "none"
    }
    if (this.hasModelTarget && this.hasModelParameterDivTarget) {
      if (!this.hasModelsWithoutParametersValue || (this.hasManualModelTarget && this.manualModelTarget.value.trim().length > 0)) {
        this.modelParameterDivTarget.style.display = ""
      } else {
        this.modelParameterDivTarget.style.display = this.modelsWithoutParametersValue.indexOf(this.modelTarget.options[this.modelTarget.selectedIndex].text) > -1 ? "none" : ""
      }
    }

  }

  connect() {
    this.toggle()
  }
} 